import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Loading from '../../../core/Loading';
import View from '../../../views/Employee/Payroll';
import { setCompletePayrollData } from '../../../../actions';
import {
  getPayrollFile,
  getPayrollsListWithSensitiveData,
  getDatesWithPayrolls
} from '../../../../utils/apiPayroll';
import { getManagedUsersPayslips } from '../../../../utils/apiControlAccess';

/* Utils */
import { getLiteralMonth } from '../../../../utils/dates';

const formattedMonthsWithPayrolls = (datesWithPayrolls, yearIndex) => {
  const monthsFormatted =
    datesWithPayrolls.length !== 0
      ? datesWithPayrolls[yearIndex][1].map((item, index) => ({
          value: index,
          text: getLiteralMonth(item - 1),
          id: item
        }))
      : [];

  return monthsFormatted;
};

const getYearsFormmatedFromPreviousDates = previousData =>
  previousData
    .map(item => item[0])
    .map((item, index) => ({
      value: index,
      text: item,
      id: item
    }));

class Payroll extends Component {
  constructor(props) {
    super(props);

    const { latestPayrollList, datesWithPayrolls, userId, userName } = props;

    this.state = {
      loading: !latestPayrollList,
      onErrorLoadData: false,
      latestPayrollList: latestPayrollList || null,
      datesWithPayrolls: datesWithPayrolls || null,
      payrollsListWithSensitiveData: null,
      yearsWithPayrolls: datesWithPayrolls
        ? getYearsFormmatedFromPreviousDates(datesWithPayrolls)
        : null,
      monthsWithPayrolls: datesWithPayrolls
        ? formattedMonthsWithPayrolls(datesWithPayrolls, 0)
        : null,
      modalPassword: false,
      modalPayrollsList: false,
      modalRRHH: false,
      errorPassword: false,
      errorDni: false,
      payrollData: null,
      yearSelected: false,
      monthSelected: false,
      employeeSelected: {
        text: userName,
        value: userId
      },
      listManagedUsers: [],
      token: null,
      nif: ''
    };
  }

  componentDidMount() {
    const { roles, setCompletePayrollDataHandler } = this.props;
    const { latestPayrollList } = this.state;
    if (roles.includes('ROLE_ACCESS_MANAGER')) {
      getManagedUsersPayslips().then(users =>
        this.setState({
          listManagedUsers: users.map(user => ({
            text: user.nombreEmpleado,
            value: user.userId
          }))
        })
      );
    }

    if (!latestPayrollList) {
      setCompletePayrollDataHandler()
        .then(data => {
          const [latestData, previousData] = data;

          if (latestData.length) {
            const yearsFormatted = getYearsFormmatedFromPreviousDates(
              previousData
            );

            this.setState({
              latestPayrollList: latestData,
              datesWithPayrolls: previousData,
              yearsWithPayrolls: yearsFormatted,
              monthsWithPayrolls: formattedMonthsWithPayrolls(previousData, 0)
            });
          } else {
            this.setState({
              onErrorLoadData: true
            });
          }
        })
        .catch(() => {
          this.setState({
            onErrorLoadData: true
          });
        })
        .finally(() => {
          this.setState({
            loading: false
          });
        });
    }
  }

  changeYear = itemSelected => {
    const { datesWithPayrolls } = this.state;
    const indexSelected = datesWithPayrolls.findIndex(
      item => item[0] === itemSelected.id
    );

    this.setState({
      monthsWithPayrolls: formattedMonthsWithPayrolls(
        datesWithPayrolls,
        indexSelected
      )
    });
  };

  onCheckPassword = (nif, isDirectDownload) => {
    this.setState({ nif });
    if (isDirectDownload) {
      this.downloadPayroll(nif);
    } else {
      this.getPayrollsListByDate(nif);
    }
  };

  downloadPayroll = nif => {
    const { payrollData, employeeSelected, token } = this.state;
    const { payslipDate, allocationDate, entryDate, payslipType } = payrollData;

    getPayrollFile(
      payslipDate,
      allocationDate,
      entryDate,
      payslipType,
      token,
      employeeSelected.value,
      nif
    )
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute(
          'download',
          `nómina_${moment(payslipDate).format('DD/MM/YYYY')}.pdf`
        );
        document.body.appendChild(link);
        link.click();

        this.setState({
          errorPassword: false,
          errorDni: false,
          modalPassword: false
        });
      })
      .catch(error => {
        if (error.code === 403) {
          this.setState({
            errorPassword: true,
            errorDni: false
          });
        } else if (error.code === 404) {
          this.setState({
            errorPassword: false,
            errorDni: true
          });
        }
      });
  };

  getPayrollsListByDate = nif => {
    const { yearSelected, monthSelected, employeeSelected, token } = this.state;
    const monthUpdated =
      monthSelected.id < 10 ? `0${monthSelected.id}` : `${monthSelected.id}`;
    const dateFormatted = `${yearSelected.id}-${monthUpdated}`;

    getPayrollsListWithSensitiveData(
      dateFormatted,
      token,
      employeeSelected.value,
      nif
    )
      .then(response => {
        if (response.length === 1) {
          this.setState(
            {
              payrollData: response[0]
            },
            () => this.downloadPayroll(nif)
          );
        } else {
          this.setState({
            payrollsListWithSensitiveData: response,
            modalPayrollsList: true
          });
        }
        this.setState({
          errorPassword: false,
          errorDni: false,
          modalPassword: false
        });
      })
      .catch(error => {
        if (error.code === 403) {
          this.setState({
            errorPassword: true,
            errorDni: false
          });
        } else if (error.code === 404) {
          this.setState({
            errorPassword: false,
            errorDni: true
          });
        }
      });
  };

  setEmployeeSelected = employee => {
    getDatesWithPayrolls(employee.value)
      .then(response => {
        const yearsPlusMonths = Object.entries(
          response
        ).sort((firstItem, secondItem) =>
          firstItem[0] < secondItem[0] ? 1 : -1
        );
        const years =
          yearsPlusMonths.length !== 0
            ? getYearsFormmatedFromPreviousDates(yearsPlusMonths)
            : [];
        const months =
          yearsPlusMonths.length !== 0
            ? formattedMonthsWithPayrolls(yearsPlusMonths, 0)
            : [];
        this.setState({
          datesWithPayrolls: yearsPlusMonths,
          employeeSelected: employee,
          yearsWithPayrolls: years,
          monthsWithPayrolls: months
        });
      })
      .catch(error => {
        throw error;
      });
  };

  render() {
    const {
      loading,
      latestPayrollList,
      payrollsListWithSensitiveData,
      yearsWithPayrolls,
      monthsWithPayrolls,
      modalPassword,
      modalPayrollsList,
      modalRRHH,
      errorPassword,
      errorDni,
      onErrorLoadData,
      employeeSelected,
      listManagedUsers,
      nif
    } = this.state;

    return loading ? (
      <Loading size="xl" />
    ) : (
      <View
        changeYear={this.changeYear}
        latestPayrollList={latestPayrollList}
        payrollsListWithSensitiveData={payrollsListWithSensitiveData}
        years={yearsWithPayrolls}
        months={monthsWithPayrolls}
        listManagedUsers={listManagedUsers}
        onErrorLoadData={onErrorLoadData}
        onSelectLatestPayroll={payrollData => {
          this.setState({
            payrollData,
            modalPassword: true
          });
        }}
        onSelectPreviousPayroll={(
          yearSelected,
          monthSelected,
          employeeSelected
        ) => {
          this.setState({
            yearSelected,
            monthSelected,
            employeeSelected,
            modalPassword: true
          });
        }}
        modalPassword={modalPassword}
        modalPayrollsList={modalPayrollsList}
        modalRRHH={modalRRHH}
        hideModalPassword={() => {
          this.setState({
            errorPassword: false,
            errorDni: false,
            modalPassword: false
          });
        }}
        hideModalPayrollsList={() => {
          this.setState({
            modalPayrollsList: false
          });
        }}
        openModalRRHH={() => {
          this.setState({
            modalRRHH: true
          });
        }}
        hideModalRRHH={() => {
          this.setState({
            modalRRHH: false
          });
        }}
        errorPassword={errorPassword}
        errorDni={errorDni}
        checkPassword={(password, nif, isDirectDownload) =>
          this.onCheckPassword(password, nif, isDirectDownload)
        }
        onClickPayrollWithSensitiveData={payrollData => {
          this.setState(
            {
              payrollData,
              modalPayrollsList: false
            },
            () => this.downloadPayroll(nif)
          );
        }}
        employeeSelected={employeeSelected}
        setEmployeeSelected={employee => this.setEmployeeSelected(employee)}
      />
    );
  }
}

const mapStateToProps = ({ payroll, user }) => ({
  latestPayrollList: payroll.latestPayrollList,
  datesWithPayrolls: payroll.datesWithPayrolls,
  roles: user.user.roles,
  userId: user.user.userId,
  userName: `${user.user.name} ${user.user.lastname}`
});

const mapDispatchToProps = dispatch => ({
  setCompletePayrollDataHandler: () => setCompletePayrollData(dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Payroll);
